import { userConstants } from "constants/user"

//apply base url for axios
const API_URL = process.env.REACT_APP_APIURL || ""

const headers = (headers = {}) => {
  try {
    return {
      userRefId: localStorage.getItem(userConstants.STORAGE.ACOUNT)
        ? JSON.parse(localStorage.getItem(userConstants.STORAGE.ACOUNT)).uid
        : "",
      "x-access-token": localStorage.getItem(userConstants.STORAGE.TOKEN) || "",
      mode: "no-cors",
      ...headers,
    }
  } catch (error) {
    return {
      userRefId: "",
      "x-access-token": "",
      mode: "no-cors",
      ...headers,
    }
  }
}

const urls = url => {
  if (process.env.NODE_ENV === "production") return `${API_URL}${url}`
  return url
}

const expiredUser = responseStatus => {
  if (responseStatus === 401) {
    localStorage.clear()
    localStorage.setItem(userConstants.STORAGE.IS_INVALID_TOKEN, true)
    window.location.href = "/login"
  }
}

export async function get(url, config = {}) {
  try {
    const response = await fetch(urls(url), {
      method: "GET",
      mode: "cors",
      headers: headers({
        "Content-Type": "application/json",
      }),
    })

    expiredUser(response.status)
    return response.json()
  } catch (error) {
    return error
  }
}

export async function post(url, data, config = {}) {
  try {
    const response = await fetch(urls(url), {
      method: "POST",
      mode: "cors",
      headers: headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        ...data,
      }),
    })

    expiredUser(response.status)

    return response.json()
  } catch (error) {
    return error
  }
}

export async function postMultipart(url, data, config) {
  try {
    const response = await fetch(urls(url), {
      method: "POST",
      mode: "cors",
      headers: headers(),
      body: data,
    })

    expiredUser(response.status)

    return response.json()
  } catch (error) {
    return error
  }
}

export async function put(url, data, config = {}) {
  try {
    const response = await fetch(urls(url), {
      method: "PUT",
      mode: "cors",
      headers: headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        ...data,
      }),
    })

    expiredUser(response.status)

    return response.json()
  } catch (error) {
    return error
  }
}

export async function del(url, data, config = {}) {
  try {
    const response = await fetch(urls(url), {
      method: "DELETE",
      mode: "cors",
      headers: headers({
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        ...data,
      }),
    })

    expiredUser(response.status)

    return response.json()
  } catch (error) {
    return error
  }
}
